import { render, staticRenderFns } from "./ShortUrlForm.vue?vue&type=template&id=48b60f73&scoped=true&"
import script from "./ShortUrlForm.vue?vue&type=script&lang=js&"
export * from "./ShortUrlForm.vue?vue&type=script&lang=js&"
import style0 from "./ShortUrlForm.vue?vue&type=style&index=0&id=48b60f73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b60f73",
  null
  
)

export default component.exports